export default __webpack_public_path__ + "static/media/platformio.bc5f6da4.svg";